import * as React from 'react';
const SvgPlus = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.857 20h4.286v-7.857H20V7.857h-7.857V0H7.857v7.857H0v4.286h7.857z" />
  </svg>
);
export default SvgPlus;
